export default (teams = []) => ({
    teams,
    keys: [],
    tagging: null,

    init() {
        this.$watch('tagging', () => {
            const team = _.get(this.teams, this.tagging, {})
            this.$dispatch('tagging::change', {team: team.id});

            if(this.tagging !== null) {
                this.$nextTick(() => this.$el.scrollLeft = this.$el.scrollWidth);
            }
        })
    },

    addKey(index) {
        this.keys[index] = String(index + 1);
    },

    keyUp({ key }) {
        if(['Enter', 'Escape'].includes(key)) {
            this.tagging = null;

            key === 'Enter'
                ? this.$dispatch('tagging::submit')
                : this.$dispatch('tagging::cancel');

            return;
        }

        this.pressKey(key);
    },

    pressKey(key) {
        if(!this.keys.includes(String(key)) || this.tagging !== null) {
            return;
        }

        this.tagging = parseInt(key) - 1;
    }
});
